import {useEffect} from 'react'
import {useLocation} from 'react-router'
import clsx from 'clsx'
import {useLayout} from '../../core'
import {DrawerComponent} from '../../../assets/ts/components'
import {WithChildren} from '../../../helpers'
import { useAppSelector } from '../../../../app/redux/hook'

const Content = ({children}: WithChildren) => {
  const {config, classes} = useLayout()
  const location = useLocation()

  const isTempltEditorFlag = useAppSelector(state => state.persistor._template.isTemplateEditor)
  // console.log("isTempltEditorFlag===: ", isTempltEditorFlag)
  
  useEffect(() => {
    DrawerComponent.hideAll()
  }, [location])

  const appContentContainer = config.app?.content?.container
  return (
    <div id='kt_app_content' className={clsx('app-content flex-column-fluid', classes.content.join(' '), config?.app?.content?.class)}>
      {appContentContainer ? (
        <div
          id='kt_app_content_container'
          className={clsx(
            `app-container h-100 ${isTempltEditorFlag ? "bg-gray-600":""}`,            
            classes.contentContainer.join(' '),
            {
              'container-xxl': appContentContainer === 'fixed',
              'container-fluid': appContentContainer === 'fluid',
            }            
          )}
          // style={{paddingLeft:'0!important', paddingRight:'0!important'}}
          // ref={(node) => {
          //   if (node) {
          //     node.style.setProperty("paddingLeft", "0px", "important");
          //     node.style.setProperty("paddingRight", "0px", "important");
          //   }
          // }}
        >
          {children}
        </div>
      ) : (
        <>{children}</>
      )}
    </div>
  )
}

export {Content}
